// extracted by mini-css-extract-plugin
export var anchor = "_43-0";
export var discard = "_43-4";
export var muiTooltipTooltip = "_43-6";
export var notificationBar = "_43-3";
export var saveButtonHoverSlotWrapper = "_43-5";
export var show = "_43-2";
export var spacer = "_43-1";